/*

Poornima 09/19/2022 2701290703 Fixed GAL-127,132,73,60,104 bugs
Poornima 09/26/2022 2701290703 Fixed global field changes
Sohel 10/06/2022 2701290703 Record Format ->Map Variables ->Search Table Payload Changes, Catagory Lookup
Sohel 10/07/2022 2701290703 Record Format ->Download configuration payload changes and hide system notes(
Dilip 10/10/2022 2701290703 visbility icon changed to Datausage
Dilip 10/10/2022 2701290703 changed Visibility To Datausage icon
Rohini 10/27/2022 2701290703 Added classname for the table and enhanced the buttons as per the new designs.
akhila 10/27/2022 2701290703  record format UX Changes
ashraf 10/27/2022 2701290703  fixed download issue
  saikrishna 11/03/2022 2701290703 changed the paginationOptions

*/

import {Button, Grid, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import React, {createRef, useState, useEffect, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {tableIcons} from '../../../../components/TableIcons';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {
  fetchRecordFormat,
  postPrintRecordFormat,
  ResetMessage as resetMessage,
  fetchRecordFormatUsage,
} from '../../../../redux/reducers/BRE/AddRecordFormat';
import {httpPaginationDelete, httpPaginationPost} from '../../../../util/Rest';
import {useUpdateEffect} from 'react-use';
import MouseOverPopover from '../../../../components/MousePopOver/MousePopOver';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useLocation} from 'react-router-dom';
import PageLoader from './../../../../components/PageLoader/index';
import {
  ErrorSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from './../../../../components/CustomSnackBar/index';
import {postPrintUsage, resetPrintUsageData} from '../../../../redux/reducers/printUsage';
import {resetUsageData} from '../../../../redux/reducers/BRE/AddRecordFormat';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import OverrideRule from '../../../../components/OverrideRule';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import {tablePageRows} from '../../../../constants/ReusableConstants';
const RecordFormatSearchTable = ({
  setValue,
  searchData,
  setRecordFormatCode,
  submit,
  setSubmit,
  formatType,
  setIsCopyIcon,
  isCopyIcon,
  setNotesEnable,
  setRowSelected,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const location = useLocation();
  const [usageWarning, setUsageWarning] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [rows, setRows] = useState(defaultRows);
  const [status, setStatus] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [isUsage, setIsUsage] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [order, setOrder] = useState({});
  const {searchRecordFormatFieldData, successMsg, errorMsg, isLoading, recordFormatUsageData} =
    useSelector(({addRecordFormat}) => addRecordFormat);
  const {roleData} = useSelector(({role}) => role);
  const disabledByRole = roleData?.window?.['Record Format']?.RF?.delete;
  useEffect(() => {
    if (tableRef?.current && submit) {
      tableRef.current.onQueryChange();
    }
  }, [submit]);

  useEffect(() => {
    if (recordFormatUsageData.userMetrix === 'No' && deleted !== true) {
      dispatch(resetUsageData());
      setUsageWarning(true);
      setTimeout(() => {
        setUsageWarning(false);
      }, 3000);
    } else if (recordFormatUsageData.userMetrix === 'Yes' && deleted !== true) {
      setUsageWarning(false);
      setValue(3);
    } else if (recordFormatUsageData.userMetrix === 'Yes' && deleted === true) {
      setIsUsage(true);
      setIsDelete(false);
    } else if (recordFormatUsageData.userMetrix === 'No' && deleted === true) {
      setIsDelete(true);
      setIsUsage(false);
    }
  }, [recordFormatUsageData]);

  useEffect(() => {
    isCopyIcon && setIsCopyIcon(false);
    setUsageWarning(false);
  }, []);
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);
  useEffect(() => {
    setRowSelected && setRowSelected(false);
  }, []);
  const handleDelete = (rowData) => {
    setDeleted(true);
    setDeleteData(rowData);
    dispatch(
      fetchRecordFormatUsage({
        code: rowData.recordFormatCode,
        frameWorkType: rowData.frameWorkType,
        rowData: rowData,
      }),
    );
  };
  const handleClose = () => {
    setIsDelete(false);
  };

  const handleSubmit = () => {
    httpPaginationDelete(`recordFormat/delete/${deleteData?.id}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  useUpdateEffect(() => {
    if (formatType || status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [formatType, status]);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  const columns = [
    {
      title: 'Record Format Code',
      field: 'recordFormatCode',
    },
    {
      title: 'Record Format Description',
      field: 'description',
      cellStyle: {whiteSpace: 'pre-wrap', wordBreak: 'break-all'},
      render: (rowData) => (
        <>
          <MouseOverPopover
            data={rowData.description}
            popOverData={rowData.description}
            codeLength={rowData?.customerCode?.description}
          />
        </>
      ),
    },
    {
      title: 'File Type',
      field: 'type',
      render: (rowData) => rowData?.type?.toUpperCase(),
    },
    {
      title: 'Record Format Type',
      field: 'frameWorkType',
      render: (rowData) =>
        rowData?.frameWorkType === 'Enable' ?
          'Enable File Format' :
          rowData?.frameWorkType === 'RecordFormat' ?
            'Report Record Format' :
            '',
    },
  ];
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Record Format"
        value={`Are you sure want to delete this Record Format?`}
        handleSubmit={handleSubmit}
      />
      <OverrideRule
        dialogTitle="Delete Record Format"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title="This Record Format has been used in the following frameworks."
        data={recordFormatUsageData?.placeResponse}
        isOverRide={false}
      />
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `recordFormat/search/all`;
                const bodyObj = {
                  recordFormatCode: searchData?.code ? searchData.code : '',
                  frameWorkType: searchData?.formattype ? searchData.formattype : formatType,
                  description: searchData?.description ? searchData.description : '',
                  type: searchData?.fileType ? searchData.fileType?.value : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                };
                setOrder({
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                });
                if (
                  Object.keys(searchRecordFormatFieldData).length > 0 &&
                  searchRecordFormatFieldData.status
                ) {
                  bodyObj['frameWorkType'] = 'Enable';
                }

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setSubmit(false);
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setRecordFormatCode(null);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              toolbarButtonAlignment: 'left',

              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <Button type="button" variant="outlined" className={`search-btn`}>
                    Add Report Record Format
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setValue(2);
                },
              },

              location.pathname === '/record-format' && {
                icon: () => (
                  <>

                    <FileCopyOutlinedIcon
                      className={classes.copyButtonroot}
                      onClick={(rowData) => {
                        setIsCopyIcon(true);
                      }}
                    />
                  </>
                ),
                tooltip: 'Copy',
              },
              {
                icon: () => (
                  <>
                    <Button type="button" variant="outlined" className={`search-btn`}>
                      Add Enable Record Format
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setValue(2);
                },
              },
              {
                icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
                tooltip: 'Usage',
                onClick: (event, rowData) => {
                  setDeleted(false);
                  dispatch(
                    fetchRecordFormatUsage({
                      code: rowData.recordFormatCode,
                      frameWorkType: rowData.frameWorkType,
                      rowData: rowData,
                    }),
                  );
                },
              },
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />,
                  tooltip: 'Delete',
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                  disabled: !disabledByRole,
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      color="primary"
                      onClick={() => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: '',
                            code: searchData?.code ? searchData.code : '',
                            description: searchData?.description ? searchData.description : '',
                            displayName: '',
                            fileType: searchData?.fileType ? searchData.fileType?.value : '',
                            recordFormatType: searchData?.formattype ?
                              searchData.formattype :
                              formatType,
                            returnType: '',
                            sourceType:
                              formatType === 'Enable' ? 'ENABLE RECORD FORMAT' : 'RECORD FORMAT',
                          }),
                        );
                      }}
                    >
                      Download Configurations Usage
                    </Button>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      color="primary"
                      onClick={() => {
                        dispatch(
                          postPrintRecordFormat({
                            description: searchData?.description ? searchData.description : '',
                            frameWorkType: searchData?.formattype ? searchData.formattype : formatType,
                            recordFormatCode: searchData?.code ? searchData.code : '',
                            type: searchData?.fileType ? searchData.fileType?.value : '',
                            orderBy: order?.orderBy ? order?.orderBy : '',
                            orderDirection: order?.orderDirection ? order?.orderDirection : '',
                          }),
                        );
                      }}
                    >
                      Download Configurations
                    </Button>
                  </div>
                  <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
            onRowClick={(event, rowData) => {
              setRowSelected(true);
              if (
                Object.keys(searchRecordFormatFieldData).length > 0 &&
                searchRecordFormatFieldData.status
              ) {
                const {setFieldValue, setShowSearchFieldData} = searchRecordFormatFieldData;
                setFieldValue('recordFormat', rowData.recordFormatCode);
                setShowSearchFieldData(false);
              } else {
                dispatch(fetchRecordFormat(rowData.id));
                rowData.frameWorkType === 'Enable' ? setValue(2) : setValue(1);
                setRecordFormatCode(rowData.recordFormatCode);
                setNotesEnable(rowData.frameWorkType);
              }
            }}
          />
        </div>
      </Grid>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg || deleteErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg || deleteErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg || tstmsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg || tstmsg} />
      )}
      {usageWarning && <WarningSnackbar errorMsg={'This logic block is not being used anywhere'} />}
    </>
  );
};

export default RecordFormatSearchTable;
